import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from 'base/components/Snackbar';

const SuccessfulAddSnackbar = ({ open, item, onClose }) => {
  const getMessage = item => (
    <span>
      <strong>{item}</strong> was added to your cart. Yum!
    </span>
  );

  return <Snackbar onClose={onClose} open={open} message={getMessage(item)} />;
};

SuccessfulAddSnackbar.defaultProps = {
  open: false,
  onClose: () => {}
};

SuccessfulAddSnackbar.propTypes = {
  item: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func
};

export default SuccessfulAddSnackbar;
